<template>
    <div>
        <a-collapse v-model="activeAccordion">
            <a-collapse-panel :showArrow="false">
                <template v-slot:header>
                    <div class="flex">
                        <div @click.stop>
                            <vs-checkbox v-if="!readOnly"
                                v-model="masterCheckbox"
                                size="large" class="mt-5"></vs-checkbox>
                        </div>

                        <div style="flex: 1">
                            <div class="flex" style="position: relative; top: 8px;">
                                <h3 class="font-bold hoverable" @click.stop="openBill">
                                    <span v-if="item.table">Mesa {{ item.table.number }}</span>
                                    <span v-else>Delivery {{ item.startingFrom }} </span>
                                </h3> 
                            </div>
                            <div class="flex" style="position: relative; top: - 2px;"> 
                                <h5 class="font-semibold text-primary">
                                    {{ paymentValues | currency }} 
                                </h5> 
                            </div>
                        </div>
                        <div class="flex" style="position: relative; top: 10px;">
                            <div class="vx-col">
                                <span v-if="item.openedOn">{{ item.openedOn.toDate() | dateFormat('DD/MM/YYYY HH:mm') }}</span>
                                <div class="flex"  style="position: relative; top: 0px; right: 0px; flex-direction: row-reverse;">
                                    <h6 class="mt-1"> pgto<span v-show="item.payments.length > 1">s</span></h6>
                                    &nbsp
                                    <h4>{{ item.payments.length }}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <a-alert  
                    v-if="hasStandalonePayments"
                    message="Conta com pagamento avulso"
                    description="Só é possível enviar a nota da conta inteira quando há pagamentos avulsos"
                    type="info"
                    show-icon 
                    class="mb-5" />
                <a-alert  
                    v-if="hasSplittedPayments"
                    message="Múltiplos pagametos para mesmos produtos"
                    description="Só é possível enviar a nota da conta inteira quando há vários meios de pagametos para mesmos produtos"
                    type="info"
                    show-icon 
                    class="mb-5" />
                <div v-for="(payment, i) in item.payments" :key="i">
                    <div class="flex">
                        <vs-checkbox v-if="!readOnly && payment.fiscalStatus == 'pending'"
                            @change="togglePayment"
                            v-model="selection[payment.id].selected"
                            :disabled="!payment.confirmed || hasStandalonePayments || hasSplittedPayments"
                            @click.stop
                            size="large" >
                        </vs-checkbox>
                        <span class=" flex w-7/12" style="flex: 1">
                            <span :class="{ 'disabled': !payment.confirmed }" class="flex">
                                <h5 style="position: relative; top: 3px;">{{ paymentDesc(payment) }}</h5>
                                <vx-tooltip v-if="!payment.orderIds || !payment.orderIds.length" text="Este foi um pagamento avulso, sem produtos associados">
                                    <vs-icon icon="info" size="20px" class="ml-3"/>
                                </vx-tooltip>
                            </span>
                            <vs-chip v-if="payment.fiscalStatus == 'done'" color="success" class="ml-2">
                                Emitido
                            </vs-chip>
                            <vs-chip v-else-if="payment.fiscalStatus == 'ignored'" color="warning" class="ml-2">
                                Ignorado
                            </vs-chip>
                            <vs-chip v-if="payment.fiscalStatus == 'error'" color="warning" class="ml-2">
                                <vs-avatar icon="warning" text-color="warning" color="white"/>
                                Contingência
                            </vs-chip>
                            <vs-chip v-if="!payment.confirmed" color="primary" class="ml-2">
                                Não confirmado
                            </vs-chip>
                            <!-- <span class="text-primary" v-if="!payment.confirmed"><b> (Não confirmado)</b></span>  -->
                        </span>
                        <span class="text-right font-bold" :class="{ 'disabled': !payment.confirmed }" style="position: relative; top: 2px;">
                            {{ payment.value | currency }}
                        </span>
                    </div>
                    <vs-divider v-if="i < item.payments.length - 1" class="w0"/>
                </div>

            </a-collapse-panel>
        </a-collapse>

        <modal-users-orders
            viewOnly
            :visible="modalBill.visible"
            :table="modalBill.table"
            @close="(value) => modalBill.visible = value" />
    </div>
</template>

<script>
import hash from '../../hash';
import ModalUsersOrders from '@/components/bill/ModalUsersOrders'
import firebase from 'firebase';
import 'firebase/functions';

const firestore = firebase.firestore();

    export default {
        components: {
            ModalUsersOrders
        },
        props: {
            item: {
                type: Object,
                required: true
            },
            selectAll: Boolean,
            readOnly: Boolean
        },
        watch: {
            selectAll (value) {
                this.masterCheckbox = value;
            },
            ['item.payments']: {
                handler (payments) {
                    this.selection = {};
                    this.$emit('select', {});
                    this.populateSelection(payments);
                    this.$nextTick(() => {
                        this.$emit('select', this.selection);
                    });
                },
                immediate: true
            }
        },
        data() {
            return {
                activeAccordion: '',
                selection: {},
                modalBill: {
                    visible: false,
                    table: null
                }
            }
        },
        computed: {
            masterCheckbox: {
                get () {
                    return Object.values(this.selection).reduce((prev, curr) => prev && curr.selected, true);
                },
                set (v) {
                    Object.keys(this.selection).forEach(key => this.selection[key].selected = v);
                    this.$emit('select', this.selection);
                }
            },
            paymentValues () {
                return this.item.payments.reduce((prev, curr) => prev + curr.value, 0);
            },
            hasStandalonePayments () {
                return this.item.payments.find(p => !p.orderIds || !p.orderIds.length);
            },
            hasSplittedPayments () {
                const counts = {}
                this.item.payments.filter(p => p.orderIds && p.orderIds.length).forEach(p => {
                    counts[hash(p.orderIds)] = counts[hash(p.orderIds)] || 0;
                    counts[hash(p.orderIds)] += 1;
                });
                return Object.values(counts).find(c => c > 1);
            }
        },
        methods: {
            paymentDesc (payment) {
                switch(payment.type) {
                    case 'money':
                        return 'Dinheiro';
                    case 'card_credit':
                        return 'Cartão de Crédito';
                    case 'card_debit':
                        return 'Cartão de Débito';
                    case 'picpay':
                        return 'Picpay';
                    default:
                        return 'Desconhecido';
                }
            },
            populateSelection (payments) {
                payments.filter(p => p.fiscalStatus == 'pending')
                        .forEach(p => 
                            this.$set(
                                this.selection,
                                p.id,
                                { selected: false, billId: this.item.id, ...p }
                            )
                    );
            },
            togglePayment () {
                this.$emit('select', this.selection)
            },
            async openBill () {
                let companyId = this.$store.getters.getCompanyID;
                const billSnap = await firestore.collection(`company/${companyId}/bill`).doc(this.item.id).get();
                if (!billSnap.exists) {
                    this.$error({
                        title: 'Conta não encontrada',
                        content : `Esta conta não está mais disponível.`,
                        zIndex : 999999
                    });
                    return;
                }
                this.modalBill.table = billSnap.data();
                this.modalBill.visible = true;
            }
        },
        beforeDestroy () {
            Object.keys(this.selection).forEach(key => this.selection[key].selected = false);
            this.$emit('select', this.selection);
        },
    }
</script>

<style lang="scss" scoped>
.disabled {
    opacity: 0.5;
}
.hoverable:hover {
    color: #00F;
}
</style>